import React from "react";
import { Link } from "gatsby";
import ReactWOW from "react-wow";
import projectStart from "../../static/images/project-start1.png";

const ProjectStartArea = () => {
  return (
    <section className="project-start-area project-start-modern ptb-100">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-lg-6 col-md-12">
            <ReactWOW animation="fadeInLeft" delay=".2s">
              <div className="project-start-visual">
                <div className="project-start-bg-shape"></div>

                <div className="project-start-image-card">
                  <img
                    src={projectStart}
                    alt="Microsoft cloud transformation digital workplace and governance support"
                  />
                </div>

                <div className="project-start-badge-card">
                  <strong>Plan Before You Invest</strong>
                  <span>Microsoft 365 • SharePoint • Security • Governance</span>
                </div>
              </div>
            </ReactWOW>
          </div>

          <div className="col-lg-6 col-md-12">
            <ReactWOW animation="fadeInRight" delay=".3s">
              <div className="project-start-content">
                <span className="project-start-label">
                  Start With a Microsoft 365 Health Check
                </span>

                <h2>
                  Get a Clear Roadmap Before You Invest in Microsoft Cloud Changes
                </h2>

                <p>
                  CloudLogic reviews your Microsoft 365 tenant, licensing,
                  collaboration, SharePoint, Teams, OneDrive, security,
                  identity, governance, compliance readiness, and support needs
                  so you know what to improve first.
                </p>

                <ul className="project-start-list">
                  <li>
                    Identify setup, licensing, collaboration, security, and governance gaps
                  </li>

                  <li>
                    Prioritise implementation, optimisation, automation, and security improvements
                  </li>

                  <li>
                    Create a plain-English roadmap for Microsoft cloud growth
                  </li>
                </ul>

                <div className="cta-buttons">
                  <Link to="/contact" className="default-btn">
                    Book Health Check
                  </Link>

                  <Link to="/services" className="secondary-btn">
                    View Services
                  </Link>
                </div>
              </div>
            </ReactWOW>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectStartArea;
